import React, {lazy, Suspense} from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import {
  isLoggedin,
  isIFRAMEUrl,
  isPartnerURL,
  isONLYPC,
  defineTypeCase,
  definePartner,
  defineFilter
} from 'Root/utils';
import {
  showNavbar,
  showSidebar,
  showAppsflyer,
  showBgGradient,
  showFloatButton,
  showCustomFloatButton
} from 'Root/constants';
import {
  Home,
  Login,
  VirtualMirror,
  Quiz,
  LensCare,
  InstagramTemplate,
  CookiePolicy,
  Define
} from 'Root/pages';
import Navbar from 'Components/navbar';
import Footer from 'Components/footer';
import Context from 'Components/context';
import BackToTopButton from './components/backToTop';
const Sidebar = lazy(() => import('Components/sidebar'));
import { CustomQuiz } from 'Components/quiz';
import DownloadLookTutorialPdf from 'Components/virtualMirror/Tutorial/LooksTutorial/DownloadLookTutorialPdf';
const BgGradient = lazy(() => import('Components/commonComponents/bgGradient'));
const Tolstoy = lazy(() => import('Components/tolstoy'));
const Appsflyer = lazy(() => import('Components/helper/Appsflyer'));
const FloatButton = lazy(() => import('Components/floatButton'));
const CustomFloatButton = lazy(() => import('Components/customFloatButton'));
// const CookiePolicyFooter = lazy(() => import('Components/cookiePolicy/cookiePolicyFooter'));
import CookiePolicyFooter from 'Components/cookiePolicy/cookiePolicyFooter';

import 'Sass/components/content.scss';
import Banner from './components/banner';
import AnimationModule from './components/animationModule';
import DiscoverPage from "./pages/Discover/DiscoverPage";
import PageNotFound from "./pages/PageNotFound";

// -----------------Todo-------------------
// Fix the directory structure and move all components files accordingly
// Move all constants and process.env to Utils.js
// Break CSS at component Level & move to respective directories
// Remove ternatory operators from JSX
// Convert all yes-no to true-false
// Don't pass context as props

const PublicRoute = ({ component: Component, close, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

const SHOW_QUIZ = process.env.REACT_APP_SHOW_QUIZ;
const CUSTOM_QUIZ = process.env.REACT_APP_CUSTOM_QUIZ || 'no';
const SHOW_KAIZEN = process.env.REACT_APP_SHOW_KAIZEN || 'no';
const KAIZEN_LINK = process.env.REACT_APP_KAIZEN_LINK || '';
const SHOW_COOKIE_POLICY = process.env.REACT_APP_SHOW_COOKIE_POLICY || 'no';
const SHOW_TOLSTOY = process.env.REACT_APP_SHOW_TOLSTOY || 'no';

const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    // 每次路由变化时调用 fbq
    fbq('track', 'PageView');
  }, [location]);
};

const ContentClass = () => {
  let content_class = 'content--page';
  if(isIFRAMEUrl()) {
    content_class += ' iframe-url';
    if(isONLYPC()) {
      content_class += ' only-pc';
    }
    if(defineTypeCase()) {
      content_class += ' type-' + defineTypeCase();
    }
    if(defineFilter()) {
      content_class += ' filter-' + defineFilter();
    }
  }
  if(isPartnerURL()) {
    content_class += ' partner-' + definePartner();
  }
  return content_class;
};

const allowOneTrustSettings = (callback) => {
  setTimeout(() => {
    Optanon.AllowAll();
    callback();
  }, 500)
}

const openOneTrustBanner = (callback) => {
  setTimeout(() => {
    if(document.getElementById('onetrust-consent-sdk')) {
      document.getElementById('onetrust-consent-sdk').style='display:none!important;';
      Optanon.ToggleInfoDisplay();
      callback();
    }
  }, 5000)
}

export default class Routing extends React.Component {
  state = {
    closeVM: false,
  };
  

  componentDidMount() {
    if(process.env.REACT_APP_LOCALE === 'my') {
      !function(f,b,e,v,n,t,s) {
        if(f.fbq) return; 
        n=f.fbq=function(){n.callMethod ?
        n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
        if(!f._fbq) f._fbq=n; 
        n.push=n; 
        n.loaded=!0; 
        n.version='2.0';
        n.queue=[]; 
        t=b.createElement(e); 
        t.async=!0;
        t.src=v; 
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  
      fbq('init', '6435086079850333');
      fbq('track', 'PageView');
    }

    if (SHOW_KAIZEN === 'yes') {
      const script = document.createElement('script');
      script.src = KAIZEN_LINK;
      script.async = true;
      document.body.appendChild(script);
    }
    if (SHOW_COOKIE_POLICY === 'yes') {
      const cookiePolicyScript = document.createElement('script');
      cookiePolicyScript.src = process.env.REACT_APP_COOKIE_POLICY_LINK;
      cookiePolicyScript.setAttribute('charset', 'UTF-8');
      cookiePolicyScript.setAttribute('data-domain-script', process.env.REACT_APP_COOKIE_POLICY_KEY);
      cookiePolicyScript.setAttribute('data-document-language','true');
      document.body.appendChild(cookiePolicyScript);
      const cookiePolicyInlineScript = document.createElement('script');
      cookiePolicyInlineScript.type='text/javascript';
      cookiePolicyInlineScript.innerHTML = 'function OptanonWrapper() { }';
      document.body.appendChild(cookiePolicyInlineScript);

      // if(isIFRAMEUrl()) {
      //   openOneTrustBanner(function(){
      //     allowOneTrustSettings(function(){
      //       setTimeout(() => {
      //         document.getElementById('onetrust-consent-sdk').style='display:block!important;';
      //       }, 500);
      //     })
      //   });
      // }
    }
  }

  componentDidUpdate(prevProps) {
    // 监听路由变化，跟踪页面视图
    if (process.env.REACT_APP_LOCALE === 'my' && this.props.location !== prevProps.location) {
      fbq('track', 'PageView');
    }
  }

  handleHomeClick() {
    this.setState({ closeVM: true });

    // added to fix bug, vm box closes again n again
    const timer = setTimeout(() => {
      this.setState({ closeVM: false });
      clearTimeout(timer);
    }, 1000);
  }

  render() {
    return (
      <div className={ContentClass()}>
        {showBgGradient && !isIFRAMEUrl() && (
          <Suspense fallback={<div></div>}>
            <BgGradient />
          </Suspense>
        )}
        <Context.Consumer>
          {(context) => (
            <Router hashType="slash">
            {
              showAppsflyer && !isIFRAMEUrl() && (
                <Suspense fallback={<div></div>}>
                  <Appsflyer/>
                </Suspense>
              )
            }
              {showNavbar && !isIFRAMEUrl() && (
                <Navbar
                    onHomeClick={this.handleHomeClick.bind(this)}
                    product={context.product}
                />
              )}
              {
                showCustomFloatButton && isPartnerURL() ? (
                  <Suspense fallback={<div></div>}>
                    <CustomFloatButton />
                  </Suspense>
                ) : showFloatButton ?
                (
                  <Suspense fallback={<div></div>}>
                    <FloatButton />
                  </Suspense>
                ) : null
              }
              {showFloatButton && !isIFRAMEUrl() && (
                <Suspense fallback={<div></div>}>
                  <FloatButton />
                </Suspense>
              )}
              {/* <main className="content--main">
                <section className="content--component">
                  <Banner></Banner>
                  <AnimationModule></AnimationModule>
                </section>
              </main> */}
              {/* { SHOW_COOKIE_POLICY === 'yes' && (
                  (isLoggedin() && !isIFRAMEUrl()) ? <CookiePolicyFooter/> : null
                )
              } */}
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/home" component={Home} />
                <Route path="/discover" component={DiscoverPage} />
                <Route exact path="/define-classic" component={Define} />
                <Route exact path="/define-fresh" component={Define} />
                <Route path="/vm" component={VirtualMirror}/>
                <Route path="/cookie-policy" component={CookiePolicy}/>
                <Route path="*" component={PageNotFound}/>
              </Switch>
              {/* TODO: rm login */}
              {/* {!isLoggedin() || (isIFRAMEUrl() && defineTypeCase() !== 'six') ? null : <Footer/>} */}
              { isIFRAMEUrl() === false ? <Footer /> : null}
              <BackToTopButton/>
            </Router>
          )}
        </Context.Consumer>
      </div>
    );
  }
}
